import { prLane } from '@/lib/pr-lane';
import styles from './PrLaneBadge.module.css';

/**
 * Debug-only badge showing the active PR lane (parity with zip-directory). Renders nothing
 * unless a lane is active, so it's safe to mount unconditionally.
 */
export function PrLaneBadge() {
  if (!prLane) {
    return null;
  }
  return <div className={styles.badge}>PR Lane: {prLane}</div>;
}
